import React, { useState } from 'react';
import { default as Alert, AlertProps } from '@material-ui/lab/Alert';
import { Snackbar, SnackbarProps } from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions/transition';

type Props = {
    children: any;
};

type Config = {
    open: boolean;
    severity?: AlertProps['severity'];
    text: string;
    // TODO PB Fix it.
    anchorOrigin?: any;
};

type defaultConfigTypes = AlertProps & SnackbarProps & { text: string };

type stateContextTypes = {
    setConfig: (options: Config) => void;
};

export const NotificationStateContext = React.createContext<stateContextTypes>({
    setConfig: () => {},
});

const TransitionUp = (props: TransitionProps) => <Slide {...props} direction="up" />;

const defaultConfig: defaultConfigTypes = {
    anchorOrigin: {
        horizontal: 'left',
        vertical: 'bottom',
    },
    autoHideDuration: 3000,
    open: false,
    severity: 'success',
    text: '',
};

const NotificationStateProvider: React.FC<Props> = ({ children }) => {
    const [ config, setConfig ] = useState<defaultConfigTypes>({
        open: defaultConfig.open,
        severity: defaultConfig.severity,
        text: defaultConfig.text,
    });

    const { anchorOrigin: anchorOriginDefault, autoHideDuration } = defaultConfig;
    const { open, text, severity, anchorOrigin, } = config;

    const state = {
        setConfig,
    };

    const handleClose = (e?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') return;

        setConfig({ ...config, open: false });
    };

    return (
        <NotificationStateContext.Provider value={state}>
            <>
                {children}
                <Snackbar
                    anchorOrigin={Object.assign({}, anchorOriginDefault, anchorOrigin)}
                    autoHideDuration={autoHideDuration}
                    onClose={handleClose}
                    open={open}
                    TransitionComponent={TransitionUp}
                >
                    <Alert onClose={handleClose} severity={severity}>
                        {text}
                    </Alert>
                </Snackbar>
            </>
        </NotificationStateContext.Provider>
    );
};

export default NotificationStateProvider;
